import { TASK_STATUS } from "./taskStatus";
export default {
    [TASK_STATUS.PENDING]: "Ожидает",
    [TASK_STATUS.CANCELLED]: "На паузе",
    [TASK_STATUS.IN_PROGRESS]: "В процессе",
    [TASK_STATUS.ERROR]: "Ошибка",
    [TASK_STATUS.COMPLETED]: "Готово"
};
